export function letsPlayActivityDetailPath(clubCode, activity) {
  if (!activity?.id) return `/${clubCode}/lets-play/history`
  if (['tennis','padel','pickleball','squash'].includes(activity.sport) && activity.type === 'match') return `/${clubCode}/lets-play/${activity.sport}/match/${activity.id}`
  return activity.sport === 'golf' && activity.type === 'round'
    ? `/${clubCode}/lets-play/golf/round/${activity.id}`
    : `/${clubCode}/lets-play/activities/${activity.id}`
}

export function letsPlayDonePath(clubCode, activity) {
  return activity?.sport === 'golf' ? `/${clubCode}/lets-play/golf` : `/${clubCode}/lets-play`
}

export const letsPlayCompletionPath = (clubCode, activityId) => `/${clubCode}/lets-play/activities/${activityId}/complete`
export const letsPlayMomentPath = (clubCode, activityId) => `/${clubCode}/lets-play/activities/${activityId}/moment`
